import defaultLogoUrl from "@/assets/imgs/vexsoft_logo_menu_empresa_default.png";
import { getPhotoBase64 } from "@/services/vex/fotosVistoria";

const getLogo = async (token) => {
    const versionamento = Date.now();
    const tokenEmpresa = token.toUpperCase();

    try {
        let imgBase64 = await getPhotoBase64(
            `https://files.vexsoft.com.br/${tokenEmpresa}/logo.png?v=${versionamento}`
        );
        return imgBase64;
    } catch (error) {
        console.error(error);
        try {
            let imgBase64 = await getPhotoBase64(
                "https://files.vexsoft.com.br/VXS111/logo-vistoria.png"
            );
            return imgBase64;
        } catch (error) {
            return defaultLogoUrl;
        }
    }
};

export default getLogo;
